<div class="container-fluid px-4 mt-4 mb-5">
    <div class="cp-page-header mb-3">
        <div class="cp-page-title"><i class="fa-solid fa-microchip me-2"></i>Dispositivos</div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de Ingreso</a></li>
                <li class="breadcrumb-item"><a routerLink="/control-ingreso/registro">Registros</a></li>
                <li class="breadcrumb-item active">Dispositivos</li>
            </ol>
        </nav>
    </div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav nav-pills cp-tabs mb-4">
        <li [ngbNavItem]="1">
            <a ngbNavLink><i class="fa-solid fa-mobile-screen me-1"></i>Teléfonos</a>
            <ng-template ngbNavContent>
                <app-list-phones />
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink><i class="fa-solid fa-nfc-symbol me-1"></i>Tags NFC</a>
            <ng-template ngbNavContent>
                <app-list-tags />
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
